export default $ => {
    // Recaptcha components
    const widgets = $('[data-recaptcha]');

    // No reCapthca? We're done
    if (widgets.length === 0) {
        return;
    }

    // For each recaptcha widget add the class g-recaptcha and the data-attribute
    // sitekey
    widgets.each(function() {
        const recaptcha = $(this);
        const key = recaptcha.data('recaptcha');
        recaptcha
            .addClass('g-recaptcha')
            .attr('data-sitekey', key)
            // .attr('data-size','invisible')
            // .attr('data-callback','onSubmitRecapcha')
            .removeAttr('data-recaptcha', key)
        ;

        // Predisposizione per invisible recapcha
        // recaptcha.closest('form').on('submit',function (event)
        // {
        //     event.preventDefault();
        //     grecaptcha.execute();
        // })
    });

    function onSubmitRecapcha(token)
    {
      console.log(token);
    }

    $('<script src="https://www.google.com/recaptcha/api.js"></script>').appendTo('body');
}



// WEBPACK FOOTER //
// ./assets/js/component/recaptcha.js